// extracted by mini-css-extract-plugin
module.exports = {"title":"style_title__fUZaF","subtitle":"style_subtitle__2DHpU"};